module.exports = __webpack_public_path__ + "img/ale.64a56b8a.svg";